import { Component,Inject } from '@angular/core';
import { GEA_MES_NAVBAR_MENU_SERVICE, GeaMesNavbarModule } from '@gea-mes/navbar';
import {NavItemService,NavItem} from './nav-item.service';
import { BehaviorSubject} from "rxjs";
import { MainContentComponent } from './main-content/main-content.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [GeaMesNavbarModule, MainContentComponent]
})
export class AppComponent {
  title = 'brilliant-config';

  objectModel = {};

constructor(public navService:NavItemService,
  @Inject(GEA_MES_NAVBAR_MENU_SERVICE) private NavItem: BehaviorSubject<NavItem[]>) {
    NavItem.next(navService.navItems);
   }

  ngOnInit() {

  }
}
